module.exports = __webpack_public_path__ + "img/珠海格力新经济创投中心.624c0fa8.png";